import React, { useContext, useState } from "react";
import CountryContext from "../CountryContext";
import { useHistory } from "react-router-dom";
import ConfiguratorSurveyTitle from "./ConfiguratorSurveyTitle";
import NotificationPing from "../ui-components/NotificationPing";
import {ArrowDownTrayIcon, PencilIcon, TrashIcon, DocumentDuplicateIcon, EyeIcon} from "@heroicons/react/24/outline";
import IconButton from "@ui-components/IconButton";
import {CalculatorDollarIcon} from "@ui-components/icons";
import Spinner from "../ui-components/Spinner";
import Checkbox from "@ui-components/Checkbox";
import {useIntl} from "react-intl";
import useCountryAxiosInstance from "@hooks/useCountryAxiosInstance";
import AuthenticationService from "../services/AuthenticationService";
import SearchSelect from "../ui-components/SearchSelect";
import {surveySpecifiedStatusOptions} from "../utils/constants";

const WorksiteDetailSurveyBlock = ({
  survey,
  last,
  worksite,
  setDeleteSurvey,
  service,
  associatedServices,
  creators,
  setApExportSurvey,
  setEditedSurveyData,
  setCreateFromDesignModalData,
  duplicateSurvey,
  isDuplicatingSurvey,
  iconButtonsDisabled,
  setServicesSurveys,
  freezed
}) => {

  const intl = useIntl();
  const {country} = useContext(CountryContext);
  const countryApiRequest = useCountryAxiosInstance(country?.code);
  const [settingSpecified, setSettingSpecified] = useState(false);
  const userScopes = AuthenticationService.getUserScopes();

  const setSpecifiedStatus = async (surveyId, v) => {
    setSettingSpecified(true);
    const refetchedSurvey = await countryApiRequest.post(`/service_surveys/set_specified_status/${surveyId}`, {
      specified_status: v,
    });
    setServicesSurveys((prev) =>
      prev.map((s) => (s.id === surveyId ? refetchedSurvey : s)));
    setSettingSpecified(false);
  }
  const history = useHistory();
  const {
    country: { code },
  } = useContext(CountryContext);

  return (
    <div
      style={last ? { border: 0 } : {}}
      className="items-center border-b overflow-hidden px-3 py-2 flex justify-between gap-3"
      key={survey.id}
    >
      <div className="flex items-center gap-2">
        {survey.isNew && <NotificationPing />}
        <ConfiguratorSurveyTitle
          service={service}
          survey={survey}
          creators={creators}
          setEditedSurveyData={setEditedSurveyData}
          freezed={freezed}
        />
      </div>
      <div className={"flex flex-col md:flex-row gap-1 items-center"}>
        {
          !worksite.flg_test &&
          userScopes.includes("service_survey:read_specified") ?
            settingSpecified ?
              <div className={"relative w-6 h-6"}>
                <Spinner styleType={"white"}/>
              </div> :
              <div className={"flex flex-col gap-y-1 items-center justify-start mt-2"}>
                <SearchSelect
                  isDisabled={freezed}
                  value={{
                    value: survey.specified_status,
                    label: intl.formatMessage({id: `worksite_survey_${survey.specified_status}`})
                  }}
                  onChange={async (e) => {
                    await setSpecifiedStatus(survey.id, e.value);
                  }}
                  options={surveySpecifiedStatusOptions.map((option) => ({
                    value: option.value,
                    label: intl.formatMessage({id: option.label})
                  }))}
                />
              </div> : null
        }
        <div className="flex gap-2">
          {!!service?.has_active_aps && (
            <IconButton
              Icon={ArrowDownTrayIcon}
              styleType="empty"
              onClick={() => {
                if (!survey.complete) return;
                setApExportSurvey(survey);
              }}
              disabled={iconButtonsDisabled}
            />
          )}
          {isDuplicatingSurvey ?
            <div className="relative w-10 h-10">
              <Spinner styleType={"white"}/>
            </div> :
            <IconButton
              Icon={DocumentDuplicateIcon}
              styleType="empty"
              onClick={() => {
                duplicateSurvey(survey.id);
              }}
              disabled={iconButtonsDisabled || freezed}
            />}
          <IconButton
            Icon={freezed ? EyeIcon : PencilIcon}
            styleType="empty"
            onClick={() => {
              history.push(
                `/${code}/worksites/${worksite.id}/service/${service.id}/survey/${survey.id}`
              );
            }}
            disabled={iconButtonsDisabled}
          />
          <IconButton
            Icon={TrashIcon}
            styleType="empty"
            disabled={survey.not_editable || iconButtonsDisabled || freezed}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setDeleteSurvey(survey.id);
            }}
          />
          {
            service.class === 0 /* Progettazione */
            && survey.complete
            && associatedServices.length > 0
            && (
              <IconButton
                Icon={CalculatorDollarIcon}
                styleType="empty"
                onClick={() => {
                  setCreateFromDesignModalData({
                    surveyId: survey.id,
                    quotationServices: associatedServices,
                  });
                }}
                disabled={iconButtonsDisabled || freezed}
              />
            )
          }
        </div>

      </div>
    </div>
  );
};

export default WorksiteDetailSurveyBlock;
